export default __webpack_public_path__ + "static/review-mob-ccd581f9cab6a8068ccd603ebb804821.svg";